<template>
  <div id="room-image" class="grid">
    <div class="grid-title">
      <h4>{{ $t("ROOM_IMAGE") }}</h4>
    </div>
    <div class="room-gallary grid-body p-3 border-top-unset">
      <span class="tip mt-3">{{ $t("TIPS") }}: {{ $t("TIP_MAIN_ROOM_IMAGE") }}.</span>
      <image-gallery
        :uploadedFiles="roomImages"
        :totalFiles="roomImages.length"
        @setMainImage="setMainImage"
        @deleteImage="deleteImage"
        ref="imageGallary"
      >
        <v-btn class="ml-2" color="primary" slot="upload-btn" @click="upload">
          <v-icon dark>
            mdi-plus
          </v-icon>
        </v-btn>
      </image-gallery>
    </div>
    
    <upload-dialog
      :uploadDialog="true"
      :sourceFile="roomImages"
      @uploadTargetImage="uploadTargetImage"
      ref="uploadComponent"
    >
      <div slot="header" class="tab-header">
        <label class="tab-title">{{ $t("LIBRARY") }}</label>
      </div>
    </upload-dialog>
  </div>
</template>

<script>
import UploadDialog from "@/components/Utils/UploadDialog.vue";
import ImageGallery from "@/components/HotelSetting/GalleryManager/ImageGallery.vue";
import { _alert } from "@/_helpers/function.js";
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";
export default {
  components: {
    "image-gallery": ImageGallery,
    "upload-dialog": UploadDialog
  },
  props: {},
  data() {
    return {
      roomImages: [],
      uploadDialog: false,
      roomId: this.$route.params.id,
      mainId: null
    };
  },
  created() {
    this.initialize();
  },
  mounted() {
    document
      .querySelector(".v-tab.v-tab--active")
      .classList.remove("v-tab--active");
    document
      .querySelector(".v-tab[tabIndex='2']")
      .classList.add("v-tab--active");
    if (
      document
        .querySelector(".v-tab[tabIndex='2']")
        .classList.contains("v-tab--disabled")
    ) {
      document
        .querySelector(".v-tab[tabIndex='2']")
        .classList.remove("v-tab--disabled");
    }
  },
  watch: {
    roomImages(value) {
      this.mainId = value.length ? value[0].id : 0;
    }
  },
  computed: {},
  methods: {
    initialize() {
      service.getRoomImages(this.roomId).then(res => {
        if (res.data.length > 0) {
          this.mainId = res.data.find(x => x.main)
            ? res.data.find(x => x.main).id
            : 0;
          if (this.mainId) this.roomImages.push(res.data.find(x => x.main));
          this.roomImages.push(...res.data.filter(x => !x.main));
        }
      });
    },
    upload() {
      this.$refs.uploadComponent.open();
    },
    uploadTargetImage(data) {
      let listNewId = [];
      let temp = [...this.roomImages];
      let listOldId = [];
      listOldId = temp.map(x => {
        return x.id;
      });
      data.forEach(x => {
        if (!listOldId.includes(x.id)) temp.push(x);
        listNewId.push(x.id);
      });
      let params = {
        mainId:
          this.mainId || temp.map(x => x.id).filter(x => x != this.mainId)[0],
        images: temp.map(x => x.id).filter(x => x != this.mainId)
      };
      service.updateRoomImages(this.roomId, params).then(res => {
        _alert(res, this.$t(res.data), false);
        if (res.responseCode == 0) {
          this.roomImages = [...temp];
        }
      });
      this.$refs.imageGallary.removeAllSelected();
    },
    setMainImage(data) {
      let params = {
        mainId: data[0].id,
        images: data.slice(1, data.length).map(x => x.id)
      };
      service.updateRoomImages(this.roomId, params).then(res => {
        _alert(res, this.$t(res.data), false);
      });
    },
    deleteImage(listRemoveId) {
      let listNewItem = this.roomImages.filter(
        x => !listRemoveId.includes(x.id)
      );
      if (!listNewItem.length) {
        listNewItem.push(this.roomImages[0]);
      }
      let params = {
        mainId: 0,
        images: []
      };
      if (listNewItem && listNewItem.length) {
        params = {
          mainId: listNewItem[0].id,
          images:
            listNewItem.length > 1
              ? listNewItem.slice(1, listNewItem.length).map(x => x.id)
              : [listNewItem[0].id]
        };
      }
      service.updateRoomImages(this.roomId, params).then(res => {
        if (listNewItem.length > 1) {
          _alert(res, this.$t(res.data), false);
        }
        if (res.responseCode == 0) {
          this.roomImages = listNewItem;
        }
      });
      if (listNewItem.length == 1) {
        let message = this.$t("MAIN_IMAGES_MUST_EXIST");
        if (this.roomImages.length > 1) {
          setTimeout(function() {
            _alert(null, message, false);
          }, 1000);
        } else {
          _alert(null, message, false);
        }
      }
    }
  }
};
</script>
